import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher({ variant = 'desktop', className = '' }) {
  const { i18n, t } = useTranslation();
  const current = (i18n.language || 'es').split('-')[0];

  const setLang = (lng) => {
    if (lng !== current) {
      i18n.changeLanguage(lng);
    }
  };

  if (variant === 'mobile') {
    return (
      <div
        className={`w-full flex items-center justify-between px-4 py-3 rounded-xl text-gray-700 ${className}`}
        role="group"
        aria-label={t('languageSwitcher.label')}
      >
        <span className="flex items-center gap-2 text-sm font-medium">
          <Globe className="w-4 h-4 text-gray-400" />
          {t('common.language')}
        </span>
        <div className="inline-flex rounded-full border border-gray-200 overflow-hidden">
          <button
            type="button"
            onClick={() => setLang('es')}
            aria-pressed={current === 'es'}
            aria-label={t('languageSwitcher.spanishFull')}
            className={`px-3 py-1.5 text-xs font-semibold transition-colors min-h-[36px] ${
              current === 'es'
                ? 'bg-[#134168] text-white'
                : 'bg-white text-gray-600 hover:bg-gray-50'
            }`}
          >
            {t('languageSwitcher.es')}
          </button>
          <button
            type="button"
            onClick={() => setLang('en')}
            aria-pressed={current === 'en'}
            aria-label={t('languageSwitcher.englishFull')}
            className={`px-3 py-1.5 text-xs font-semibold transition-colors min-h-[36px] ${
              current === 'en'
                ? 'bg-[#134168] text-white'
                : 'bg-white text-gray-600 hover:bg-gray-50'
            }`}
          >
            {t('languageSwitcher.en')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`inline-flex items-center rounded-full border border-gray-200 overflow-hidden ${className}`}
      role="group"
      aria-label={t('languageSwitcher.label')}
    >
      <button
        type="button"
        onClick={() => setLang('es')}
        aria-pressed={current === 'es'}
        aria-label={t('languageSwitcher.spanishFull')}
        className={`px-3 py-1.5 text-xs font-semibold transition-colors ${
          current === 'es'
            ? 'bg-[#134168] text-white'
            : 'bg-white text-gray-600 hover:bg-gray-100'
        }`}
      >
        {t('languageSwitcher.es')}
      </button>
      <button
        type="button"
        onClick={() => setLang('en')}
        aria-pressed={current === 'en'}
        aria-label={t('languageSwitcher.englishFull')}
        className={`px-3 py-1.5 text-xs font-semibold transition-colors ${
          current === 'en'
            ? 'bg-[#134168] text-white'
            : 'bg-white text-gray-600 hover:bg-gray-100'
        }`}
      >
        {t('languageSwitcher.en')}
      </button>
    </div>
  );
}
